<i18n>
{
  "de": {
    "noOfferpublished": "hat noch kein Angebot veröffentlicht."
  },
  "en": {
    "noOfferpublished": "has not published an offer yet."
  }
}
</i18n>

<template>
  <section class="section mt-20">
    <div class="container">
      <div class="columns">
        <div
          class="column"
          :class="isMobileView ? 'is-hidden' : 'is-one-quarter'"
        >
          <sidenav />
        </div>
        <div
          v-if="artist.products.length"
          class="column"
        >
          <profile-product
            v-for="(product, index) in sortedProducts"
            :key="product._id"
            :product="product"
            :highlight="highlight"
            :listview="true"
            :sideview="false"
            :index="index"
          />
        </div>
        <div
          v-else
          class="column"
        >
          <div class="box">
            <h2>{{ artist.nickname }} {{ $t('noOfferpublished') }}</h2>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapState } from 'vuex'
import sidenav from '~/components/sidenav'
import profileProduct from '~/components/profile-product'

export default {
  components: {
    profileProduct,
    sidenav
  },

  data() {
    return {
      productId: null,
      scrollAnimation: false
    }
  },

  async asyncData({ params, app, store, req }) {
    if (!params.productId) {
      params.productId = null
    }
    return params
  },

  head() {
    return {
      title: `${this.artist.nickname} - Products`
    }
  },

  computed: {
    sortedProducts() {
      if (this.artist && this.artist.products) {
        return this.artist.products.slice().sort((a, b) => {
          if (a.updatedAt < b.updatedAt) return 1
          if (a.updatedAt > b.updatedAt) return -1
          return 0
        })
      }
      return []
    },
    ...mapState(['artist']),

    highlight() { return this.amount }
  },

  mounted() {
    if (this.scrollAnimation && this.productId) {
      const selectedProduct = this.sortedProducts.filter(p => p._id.toString() === this.productId)[0]
      if (selectedProduct) {
        this.$scrollTo(document.querySelector(`#product_${selectedProduct._id}`))
      }
    }
  }
}
</script>

<style lang="scss">
@import 'assets/sass/_variables';

h2 {
  color: var(--secondary-color);
}
</style>
